<h2 mat-dialog-title>Extensiones de servicio de {{ nombreUsuario }}</h2>
<mat-dialog-content>
  <mat-form-field appearance="outline" >
    <mat-label>Filtro</mat-label>
    <input matInput (keyup)="applyFilter($event)" placeholder="Filtro" #input />
  </mat-form-field>

  <div class="mat-elevation-z1 contenedorTabla" *ngIf="!isLoadingResults">
    <table mat-table [dataSource]="dataSource">
      <ng-container matColumnDef="nombre">
        <th mat-header-cell *matHeaderCellDef>Nombre</th>
        <td mat-cell *matCellDef="let element">{{ element.usuario }}</td>
      </ng-container>

      <ng-container matColumnDef="usuarioCreador">
        <th mat-header-cell *matHeaderCellDef>Creador</th>
        <td mat-cell *matCellDef="let element">{{ element.usuarioCreador }}</td>
      </ng-container>

      <ng-container matColumnDef="fechaAnterior">
        <th mat-header-cell *matHeaderCellDef>Fecha anterior</th>
        <td mat-cell *matCellDef="let element">{{ element.fechaAnterior | date: 'dd-MM-yyyy' }}</td>
      </ng-container>

      <ng-container matColumnDef="fechaNueva">
        <th mat-header-cell *matHeaderCellDef>Nueva fecha</th>
        <td mat-cell *matCellDef="let element">{{ element.fechaNueva | date: 'dd-MM-yyyy' }}</td>
      </ng-container>

      <ng-container matColumnDef="comentario">
        <th mat-header-cell *matHeaderCellDef>Comentario</th>
        <td mat-cell *matCellDef="let element">{{ element.comentario }}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>

    <mat-paginator
      #paginator
      [length]="length"
      [pageIndex]="pageIndex"
      [pageSize]="pageSize"
      [pageSizeOptions]="[10, 25, 100]"
      (page)="getServerData($event)"
    ></mat-paginator>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <!--  <button type="submit" mat-button mat-flat-button color="primary" (click)='guardar()' [disabled]="registerForm.invalid">Guardar</button> -->
  <button mat-button mat-dialog-close="false">Cerrar</button>
</mat-dialog-actions>
